// 新闻列表
export default {
  newsList: [
    // 2026 年
    {
      id: 17,
      time: {
        year: '2026',
        month: '04/27'
      },
      name: '2026年CPO能否实现大规模量产？',
      detail: 'CPO通过将光学引擎与交换机硅芯片紧密集成，有望带来前所未有的带宽密度与能源效率...',
      html: [
        '共封装光学(co-packaged optics；CPO)技术是下一代数据中心架构的关键推动因素，通过将光学引擎与交换机硅芯片紧密集成，有望带来前所未有的带宽密度与能源效率。那么，这项光互连技术在问世将近十年之后，在大规模商业化实现方面究竟进展到哪一步？',
        '在深入探讨CPO的技术蓝图与未来部署前景之前，先简要介绍一下这种硅光子架构，以及它如何强化人工智能(AI)、高性能计算(HPC)与高速网络应用，特别是在铜线传输电信号已逐渐逼近物理极限的情境下。',
        {
          img: require('@/assets/images/news/news_30.png')
        },
        'CPO通过将光学组件直接集成于单一封装内，大幅缩短电信号传输路径，显著降低信号损耗、提升高速信号完整性，并抑制延迟。换言之，CPO借由高带宽光学引擎来提升数据吞吐量，这些光学引擎可提供更高的数据传输速率，且相较于传统铜线连接方式，更不易受到电磁干扰(EMI)的影响。',
        '此外，这种硅光子集成也能改善能源效率，因为它降低了对高功率电驱动器、中继器与重定时器的需求。具体而言，通过缩短铜线走线距离，CPO可大幅改善链路预算，甚至足以省去数字信号处理器(DSP)或重定时器功能，从而显著降低每位(bit)的整体功耗，而这正是AI数据中心管理中的关键衡量指标。',
        '以下将简要回顾2025年间CPO的重要动态，从中一窥产品发布状况以及CPO基本构成组件的实际成熟度。',
        '2025年1月，Marvell宣布其定制化XPU架构在集成CPO技术方面取得进展。该公司展示其定制化AI加速器架构，如何在同一基板上，通过高速SerDes、die-to-die接口与先进封装技术，将XPU计算芯片、HBM及其他小芯片与其3D SiPho引擎集成在一起。',
        '这样的架构消除了电信号必须离开XPU封装、进入铜缆或跨越PCB的需求。此外，XPU之间的连接可实现比传统电缆快得多的数据传输速率，且传输距离可延长至电缆的100倍。Marvell的3D SiPho引擎支持200Gbps的电与光接口。',
        'Marvell网络交换业务部高级副总裁兼总经理Nick Kucharewski表示：“AI scale-up服务器需要具备更高信号速率与更远的传输距离，以支持前所未有规模的XPU集群规模。将共封装光器件集成至定制化XPU中，是通过更高互连带宽与更长传输距离来扩展性能的合乎逻辑下一步。”',
        {
          img: require('@/assets/images/news/news_31.png')
        },
        '四个月后，也就是2025年5月，Broadcom公开展示其第三代每通道200G的CPO技术。Broadcom的CPO之路始于2021年的Tomahawk 4-Humboldt芯片组，而第二代Tomahawk 5-Bailly芯片组则成为首款进入量产的CPO解决方案。',
        'Broadcom光学系统事业部副总裁兼总经理Near Margalit表示：“Broadcom多年来持续精进CPO平台解决方案，这从第二代100G/通道产品的成熟度以及整个生态系统的完善程度即可看出来。”Broadcom同时也宣称，除了边缘交换机ASIC与光学引擎技术外，它还提供由无源光组件、互连和系统解决方案合作伙伴组成的全面生态系统。',
        {
          img: require('@/assets/images/news/news_32.png')
        },
        '2025年10月，Broadcom宣称Meta已在高温实验室验证环境中，对其CPO解决方案进行了一百万小时的测试，而且未发生任何一次link flap。所谓link flap是指短暂的连接中断，这是高性能数据中心网络中一项极为关键的可靠性指标。',
        '除了Broadcom与Marvell等CPO重量级厂商外，硅光子领域中也有多家初创公司正积极尝试突破电I/O瓶颈。例如，光互连解决方案供应商Ayar Labs，已将其TeraPHY光学引擎纳入Global Unichip Corp.(GUC)的ASIC设计服务中。',
        '2025年11月，Ayar Labs宣布将其光学引擎集成于GUC的先进封装与ASIC设计流程中，这是迈向未来CPO部署的重要一步。这项联合设计工作有助于解决CPO集成的关键挑战，包括架构、功耗与信号完整性、机械结构以及热管理等层面。',
        'Ayar Labs首席技术官兼联合创始人Vladimir Stojanovic表示：“若没有光学技术来克服电I/O瓶颈，AI与数据中心的scale-up未来将无法实现。与GUC在先进封装与硅技术上的合作，是展示我们光学引擎如何加速超大规模数据中心与AI scale-up导入共封装光学的重要一步。””',
        {
          img: require('@/assets/images/news/news_33.png')
        },
        '尽管CPO的支持者热切宣称CPO革命已近在眼前，但像Yole Group等行业观察机构则认为，大规模部署可能要到2028年至2030年间才会出现。在此之前，插在PCB边缘、位于交换机前面板的可插拔模块仍将保持竞争力。市场研究公司LightCounting也预测，在整个十年间，光学模块仍将占据数据中心中大多数的光链路。然而，同时可以观察到，光收发器技术将持续稳定地朝将光学组件放得更靠近ASIC的方向演进。',
        '原因在于，传统可插拔光学模块因交换机ASIC与光学引擎之间的电信号走线过长，正日益受到信号损耗、功耗与延迟的限制。CPO则通过将光学引擎放置在更靠近交换芯片的位置，来克服这些问题。',
        '当光学引擎逐步向交换机ASIC靠拢时，所需的电信号铜线走线长度也随之缩短，进而改善电气性能。然而，为了将光学引擎无缝地连接至交换机ASIC或XPU，仍需多种封装技术配合，包括2.5D中介层、硅通孔(TSV)、扇出型晶圆级封装，以及通过混合键合(hybrid bonding)实现的3D集成。',
        '这些先进封装技术正持续演进，CPO的实际部署也随之推进。IDTechEx预估，CPO市场规模将在2036年前突破200亿美元，并在2026年至2036年间以37%的年复合增长率(CAGR)高速增长。'
      ]
    },
    {
      id: 16,
      time: {
        year: '2026',
        month: '02/11'
      },
      name: '2026年800G以上光收发模块占比将突破60%,',
      detail: '800G以上高速光收发模块在全球出货占比预估将自2024年的19.5%上升至2026年的60%以上，并逐渐成为AI数据中心的标准配备。',
      html: [
        '根据TrendForce集邦咨询最新高速互连市场研究，为应对AI所需的庞大运算需求，Google（谷歌）新世代Ironwood机柜系统结合3D Torus网络拓扑、Apollo OCS全光网络，实现高速互连架构，将推升800G以上高速光收发模块在全球出货占比，预估将自2024年的19.5%上升至2026年的60%以上，并逐渐成为AI数据中心的标准配备。',
        '在搭配全光网络交换机OCS(optical circuit switch)的架构下，Ironwood机柜内的TPU以高速铜缆处理短距互连，跨机柜则全面改由全光网络进行数据传输，AI集群从设计阶段就被要求配置足够的800G/1.6T光模块。TrendForce集邦咨询以2026年Google TPU近400万颗的出货预估推算，对应的800G以上光模块的需求将逾600万支。',
        {
          img: require('@/assets/images/news/news_29.png')
        },
        '除了AI集群的架构领先，“省电”与“省钱”是Google这套设计的最大优势。TrendForce集邦咨询表示，Apollo OCS技术的核心在于使用「微型反射镜 (MEMS Mirror)」，让数据光纤直接对接，避免传统技术在“光”与“电”之间反复转换产生的耗能与延迟。以单台OCS交换机而言，其功耗仅约100瓦，与传统交换机的3,000瓦相比，耗电量大幅减少约95%。此外，若未来需将带宽从800G提升至1.6T时，企业只需更换高速光模块即可，不必重新打造整个系统，升级成本将更具竞争力。',
        '从供应链角度分析，预期领导厂商InnoLight（中际旭创）凭借与Google在硅光子、1.6T平台的合作基础及第二梯队的Eoptolink（新易盛）共可囊括近八成Google 800G以上光模块订单。Lumentum则在OCS系统与MEMS供应扮演关键角色，其产能规划将实际影响Apollo OCS导入节奏。',
        'TrendForce集邦咨询指出，随着算力持续堆栈，数据在机柜与机柜、集群与集群之间的传输需求同步放大。因此，高速光模块、激光等光通信零部件的技术演进与供给，将成为继GPU、存储器之外，影响算力扩充速度与成本的另一项决定性因素。'
      ]
    },
    // 2025 年
    {
      id: 15,
      time: {
        year: '2025',
        month: '10/09'
      },
      name: '“塑料神经元”问世',
      detail: '瑞典林雪平大学的研究团队成功研发出一种基于导电聚合物的“塑料神经元”，为新一代可植入人体的传感器、医疗器件以及先进机器人技术带来了广阔前景…',
      html: [
        '长期以来，人工模拟生物神经细胞的行为一直是神经形态研究的主要目标。然而，传统硅基电子器件难以与人体内的神经细胞有效沟通，因为它们运行的物理机制不同。而在最近，瑞典林雪平大学的研究团队成功研发出一种基于导电聚合物的“塑料神经元”，为新一代可植入人体的传感器、医疗器件以及先进机器人技术带来了广阔前景。',
        '据了解，这种“塑料神经元”采用一种被称为共轭聚合物的柔性有机材料，能够同时传导电子和离子，从而更接近生物神经元的信号传递方式。实验数据也显示，这些器件能够响应10毫秒的电流输入执行XOR运算，与生物神经元的典型放电时间相当。',
        {
          img: require('@/assets/images/news/news_27.png')
        },
        '为了证明该神经元能够像人类神经元一样处理信息，研究团队还展示了该神经元的“反重合检测”功能，即只有当神经元的一个输入激活而另一个输入不激活时，神经元才会被激活，这类机制在人类神经系统中广泛存在，在触觉传感方面具有极大的应用价值。',
        '研究人员指出，最新版本的塑料神经元能够再现17种神经元特性（早期版本为15种），而且尺寸已经缩小到接近人类神经元的水平。由于导电聚合物材料柔软且具备生物兼容性，这类器件未来有望直接与生物组织结合，用于神经损伤修复或神经疾病治疗。',
        '而与此前依赖复杂微纳加工工艺的人工神经元相比，新设计在制造上更为简化，更接近传统印刷电路的工艺路线，这种设计不仅降低了制造难度，也为未来的大规模生产提供了可能。',
        {
          img: require('@/assets/images/news/news_28.png')
        },
        '目前，全球范围内已有多种类脑计算尝试，例如英特尔的Loihi芯片和IBM的TrueNorth芯片，但它们仍主要依赖硅基材料，能耗和扩展性方面存在限制，相比之下，塑料神经元的研究为这一领域提供了另一种新的可能路径。不过，研究人员也强调，距离真正实现大规模应用仍有不少挑战，包括如何实现长期稳定运行、如何在大规模网络中保持性能一致性等。'
      ]
    },
    {
      id: 14,
      time: {
        year: '2025',
        month: '06/18'
      },
      name: 'PQC算法：为未来安全性准备就绪',
      detail: 'PQC算法实施于传统计算平台上，但却能同时抵挡传统与量子攻击…',
      html: [
        '量子计算(Quantum Computing)技术的发展迅速，有望解决许多社会上最棘手的问题。尽管现有的各种加密技术几乎为我们在网络上所做的一切提供了安全与隐私，然而，随着研究人员竞相开发运作方式与一般计算机截然不同的量子计算机，有些专家预测量子计算机可能可以破解目前的加密技术。',
        '“加密”(encryption)——保护着无数的电子机密，例如电子邮件内容、医疗记录和照片图库，因而在当代数字化社会中肩负重任。这主要通过加密在公共计算机网络上传送的数据而实现，除了发件人和收件者之外，其他人都无法读取。然而，更强大的量子计算机将能够破解我们日常生活中使用的传统公共密钥加密算法，例如RSA和椭圆曲线加密。因此，保护量子未来安全的需求已引发了新一波的加密创新浪潮，让后量子加密(post-quantum cryptography，PQC)成为新的网络安全标竿。',
        {
          img: require('@/assets/images/news/news_24.jpg')
        },
        '美国国家标准与技术研究院(National Institute of Standards and Technology，NIST召集了全球各地的密码学专家，共同构想、提议并评估可抵抗量子计算机攻击的密码算法。NIST早在2016年就展开了PQC标准化程序，向密码学家征求构想，然后在2022年要求他们提出其他算法。',
        '2024年8月13日，NIST宣布完成三项后量子加密标准，作为一般加密和保护数字签名的主要工具，旨在保护政府机密免受未来量子计算机的威胁。新标准基于复杂的数学算法，即使是最强大的量子计算机也很难破解。NIST数学家兼PQC标准化项目负责人Dustin Moody表示：“我们鼓励系统管理员立即开始将它们集成到系统中，因为完全集成需要时间。”',
        '美国联邦信息处理标准(Federal Information Processing Standards)—FIPS 203的主要任务是加密，其特色是加密密钥较小，让双方能以更快的速度轻松交换。FIPS 203以CRYSTALS-Kyber算法为基础，后来更名为ML-KEM，即Module-Lattice-Based Key-Encapsulation Mechanism的缩写。FIPS 204主要用于保护数字签名，使用CRYSTALS-Dilithium算法，该算法已改名为ML-DSA，是Module-Lattice-Based Digital Signature Algorithm的缩写。FIPS 205也是用于数字签名，采用Sphincs+算法，该算法已改名为SLH-DSA，是无状态哈希值数字签名(Digital Signature)算法的缩写。FIPS 203、FIPS 204 和FIPS 205是NIST PQC标准化项目的一部分，该加密IP核心供应商Xiphera已经开始更新其xQlave系列安全IP，根据NIST标准的最终版本，将ML-KEM (Kyber)用于密钥封装机制，ML-DSA (Dilithium)用于数字签名。',
        'Xiphera联合创始人兼首席技术官Kimmo Järvinen表示：“我们将在2024年第三季更新xQlave PQC IP核心，以符合这些最终标准版本。这将会是一次小幅的更新，因为截至2023年，我们已经在xQlave产品中支持早期版本的算法，并且一直非常仔细地跟进标准化进度以及加密社群内的相关讨论。”Xiphera也在其nQrux系列硬件信任引擎中加入了抗量子的安全启动功能。nQrux安全启动以纯数字逻辑为基础，不包含任何隐藏的软件组件，可加强安全性，并确保更容易验证与认证。',
        'nQrux secure boot采用混合式签名方案，包含传统方案Elliptic Curve Digital Signature Algorithm (ECDSA)与新型量子安全签名方案ML-DSA，两者皆已通过NIST标准化。即使量子计算机破解ECDSA，或新的ML-DSA标准被发现弱点，此解决方案仍能确保系统安全性。',
        {
          img: require('@/assets/images/news/news_25.jpg')
        },
        'nQrux安全启动是一个不受制于制程节点的IP核，可轻松集成于FPGA和ASIC架构中。Xiphera计划在2024年第四季度提供此IP核心供客户评估。',
        'RISC-V处理器IP供应商SiFive则与量子安全加密技术供应商PQShield合作，加速NIST的PQC标准在RISC-V技术上的采用。这将有助于设计人员利用SiFive的RISC-V处理器，打造符合NIST最近公布的PQC标准的芯片。SiFive将在其RISC-V处理器中集成PQShield的PQPlatform-CoPro安全IP，以建立抗量子的硬件信任根(root-of-trust，RoT)，进而建立安全系统的基础。SiFive首席安全架构师Yann Loisel表示：“这次合作确保了RISC-V矢量扩展的设计人员得以使用最新一代的网络安全技术。””',
        {
          img: require('@/assets/images/news/news_26.png')
        },
        '这项合作也将让PQShield的加密库首次利用RISC-V矢量扩展。另一方面，RISC-V处理器将采用全新的安全技术，提供更高级别的保护与信任。',
        '强大的量子计算机预计很快就能轻易破解目前用来保护软件和硬件应用的加密标准。因此，硬件与软件制造商已开始将半导体产品转移至PQC技术，以符合NIST的后量子加密新标准。虽然NIST仍在继续评估另外两组算法，这些算法有朝一日可能会成为备份标准，但NIST的Moody表示不必等待未来的标准：“让我们继续使用这三种算法吧。我们需要做好准备，以防万一有攻击破坏这三种标准中的算法，我们将继续制定备份计划，以确保数据安全。但对大多数应用而言，这些新标准才是重头戏。',
        '值得注意的是，虽然这些PQC算法主要实施于传统计算平台上，但却能同时抵挡传统与量子攻击。这对于汽车和工业设计中的长生命周期应用而言，是一个重要的考虑因素。',
        '随着能够破解传统公共密钥加密算法的强大量子计算机崛起，加密和网络安全的格局将持续发生改变。这对于全球网络和数据基础设施的安全基础构成了迫在眉睫的威胁。'
      ]
    },
    {
      id: 13,
      time: {
        year: '2025',
        month: '01/13'
      },
      name: '钻石电池理论寿命可达数千年',
      detail: '英国原子能管理局（UKAEA）与英国布里斯托尔大学的研究团队近日宣布，他们成功制造出世界上第一块碳-14钻石电池，这种新型电池的潜在寿命可达数千年···',
      html: [
        '英国原子能管理局（UKAEA）与英国布里斯托尔大学的研究团队近日宣布，他们成功制造出世界上第一块碳-14钻石电池，这种新型电池的潜在寿命可达数千年。',
        '碳-14是一种放射性同位素，常用于考古学中的放射性测年法，用其制造钻石电池的工作原理是利用钻石外壳吸收碳-14的放射性衰变释放的电子来产生低水平的电能。这种电池的功能类似于太阳能电池板，但它们不是使用光粒子（光子），而是从钻石结构中捕获快速移动的电子',
        {
          img: require('@/assets/images/news/news_23.png')
        },
        '据了解，碳-14的半衰期约为5700年，这意味着即使在几千年后，电池仍能保持其原始电力的一半，理论上使用寿命可达千年。这种电池还可助力可持续发展，因为碳-14是从核裂变反应堆的石墨块中提取的（石墨块是核能发电过程中产生的副产品）。通过将放射性物质转化为可用的能源，碳-14钻石电池不仅解决了核废料处理的难题，还为这些废料创造了新的价值。',
        '而由于钻石材料具有非常好的生物相容性，使其在医疗领域拥有着巨大潜力，尤其是在为心脏起搏器、助听器和眼科植入物等设备提供电力方面。并且，与传统电池相比，碳-14电池无需频繁更换，能够极大的减少患者的不适感与手术风险。此外，这种电池还可以用于地球或太空的极端工作环境中，为一些低功耗的器件提供持续供电，降低设备成本并延长使用寿命。',
        '布里斯托尔大学的研究人员表示：“我们的微功率技术可以支持从空间技术、安全设备到医疗植入物的一系列重要应用。我们很高兴能够在未来几年与行业和研究领域的合作伙伴一起探索所有这些可能性。”'
      ]
    },
    {
      id: 12,
      time: {
        year: '2024',
        month: '09/13'
      },
      name: 'Ghiplet会是GPU设计发展的下一步吗？',
      detail: '当图形处理器(GPU)以“芯粒”(chiplet)排列方式实现时，是否能够称其为‘Ghiplet’？',
      html: [
        '当图形处理器(GPU)以“芯粒”(chiplet)排列方式实现时，是否能够称其为‘Ghiplet’？这是半导体行业专家Chetan Arvind Patil最近提出的看法。',
        '有鉴于目前单芯片GPU设计面临过大且复杂而导致的GPU元件良率较低的挑战，Patil日前在他的博客发表了一篇主题为“Ghiplet半导体的崛起”(The Rise of Semiconductor Ghiplet)的文章，文章中介绍了在芯粒架构中采用GPU更胜于单芯片GPU设计的诸多优势。',
        {
          img: require('@/assets/images/news/news_20.jpg')
        },
        '随着对于更强大计算资源需求的不断增长，特别是在AI驱动的应用中，半导体行业正见证着下一重大创新进展：Ghiplet 架构的崛起。',
        '换句话说，设计中的所有渲染都由chiplet处理，而非通过大型计算GPU进行。以AMD Radeon RX 7000系列为例，它是首批基于chiplet的GPU之一，包含一个大型图形芯片和多个内存芯片。总部位于硅谷的AMD目前正考虑在GPU设计中使用更多的chiplet。',
        {
          img: require('@/assets/images/news/news_21.jpg')
        },
        '针对人工智能(AI)等高性能计算(HPC)应用，采用“ghiplet”途径有其天生的优势：内存芯片可以分散在主GPU芯片周围。因此，“ghiplet”有助于实现计算与内存之间的平衡。chiplet的模块化有助于优化内存处理等特定功能。因此，Chetan Arvind Patil强调了这一新的GPU设计趋势：',
        'Ghiplet = G(PU) + Chiplet',
        '除了内存，chiplet还能以先进的互连实现更快、更高效的数据处理。这特别适用于AI、数据分析和科学领域的高性能计算应用。GPU过渡至chiplet架构的进展缓慢；GPU大厂Nvidia(英伟达)表示，其最近推出的Blackwell GPU并非chiplet。尽管有诸多猜测，Nvidia目前仍坚持使用单芯片的策略。这在一定程度上是因为GPU比CPU更加复杂。',
        '然而，随着GPU的发展超越了图形和游戏之外的更多应用，chiplet可望为GPU设计带来极大的灵活性和扩展性。因此，AMD的竞争对手英特尔(Intel)凭借其Max系列GPU进入了“ghiplet”领域。它拥有超过1,000亿个晶体管，封装在47个不同的chiplet中——英特尔称其为tiles，其内存容量高达128GB。',
        {
          img: require('@/assets/images/news/news_22.jpg')
        },
        '模块化的chiplet架构在GPU设计的适用性似乎是毋庸置疑的。AMD和英特尔已经跃跃欲试，即将引爆这场竞争，而Nvidia的举动也备受关注。尤其是当AI应用及其对内存容量的需求与日俱增，在与GPU的搭配时更需要计算与内存的平衡。'
      ]
    },
    {
      id: 11,
      time: {
        year: '2024',
        month: '05/25'
      },
      name: 'GDDR7显存标准正式发布',
      detail: 'GDDR7是首款使用脉冲幅度调制（PAM）接口进行高频操作的JEDEC标准 DRAM，带宽是GDDR6的两倍，每台设备的带宽最高可达192GB/s···',
      html: [
        '3月5日，JEDEC固态技术协会正式发布JESD239图形双倍数据速率（GDDR7） SGRAM，该标准所提供的带宽是GDDR6的两倍，每台设备的带宽最高可达192GB/s。',
        '据介绍，GDDR7是首款使用脉冲幅度调制（PAM）接口进行高频操作的JEDEC标准 DRAM。其PAM3接口使用了三个级别的信令（+1、0、-1），可在2个周期内传输3位数据，而使用传统NRZ（不归零）接口的GDDR6，仅能在2个周期内传输2位数据，仅数据传输速率方面的提升就达到了50%。除此以外，使用PAM3接口还能提高高频操作的信噪比（SNR），并提高能效。',
        {
          img: require('@/assets/images/news/news_19.jpg')
        },
        '其他高级功能和提升包括：',
        '具有眼图掩蔽和错误计数器的核心独立LFSR（线性反馈移位寄存器）训练模式可提高训练准确性，同时减少训练时间；',
        '独立通道数量翻倍，从GDDR6中的2个增加到GDDR7中的4个；',
        '支持16Gbit至32Gbit密度，包括支持2通道模式以使系统容量加倍；',
        '通过整合最新的数据完整性功能，包括带实时报告的片上ECC（ODECC）、数据中毒、错误检查和清理以及带命令阻塞的命令地址奇偶校验（CAPARBLK），满足RAS（可靠性、可用性、可维护性）的市场需求。',
        '据悉，传统提升带宽的显存标准迭代方式，已经难以满足新兴应用领域对高性能内存快速增长的需求，此次GDDR7向PAM3信号的转变，为内存行业开辟了一条新的途径继续扩展GDDR设备的性能，使GDDR设备能够更好地服务云游戏和计算等现有市场，并扩展到AI等其他领域。',
        '从目前发布的公告来看，AMD、美光、英伟达、三星、SK 海力士都对该标准表示了支持。而根据EDN电子技术设计此前关于美光GDDR7产品的相关报道，搭载GDDR7显存的显卡预计最快在2024年末发布。'
      ]
    },
    // 2023 年
    {
      id: 10,
      time: {
        year: '2023',
        month: '11/24'
      },
      name: '英特尔展示初代集成内存Ultra处理器',
      detail: '9月6日，英特尔在官网发布了演示视频，展示了其尖端封装技术EMIB和Foveros，以及其即将推出的酷睿Ultra处理器。',
      html: [
        '英特尔在官网发布了演示视频，展示了其尖端封装技术EMIB和Foveros，以及其即将推出的酷睿Ultra（Meteor Lake）处理器。',
        '其中EMIB是指在封装内将多个小芯片并排连接，Foveros则是以3D方式将多个小芯片堆叠在一起，而演示中所展示的Meteor Lake CPU正是采用Foveros封装，同时类似于苹果的M1和M2芯片，英特尔还在这块芯片上搭载了16GB的三星LPDDR5X-7500内存，可提供120 GB/s的峰值带宽，远高于采用DDR5-5200或LPDDR5-6400的内存子系统所提供的峰值带宽。',
        '将内存与CPU封装在一起最早是从苹果开始的，而英特尔这次改进可以算是一次大胆的尝试，这种做法可以带来几个好处，包括性能提高、系统更薄以及平台占用空间减少，从而可以使用更大容量的电池，提高笔记本电脑的续航。',
        {
          img: require('@/assets/images/news/news_18.jpg')
        },
        '当然这种方式也存在着缺点，如果存储芯片发生故障，整个系统就会出现故障，同时因为内存直接焊接在了平台上所以无法从外部进行升级，以及CPU和内存组合在一起需要更复杂的冷却系统。所以对于制造商来说如果使用Meteor Lake CPU就可以简化它们的制造流程，并且可以让他们制造的笔记本电脑更薄，不过相应的也会降低其笔记本电脑配置的灵活性。',
        '根据此前的爆料，英特尔Ultra 1代酷睿移动处理器的型号规格，最高6大核+8小核+8Xe  核显。在核显方面，英特尔采用了全新的低功耗图形IP，比上代增加33%的图形核心，功耗和芯片面积效率优化，支持完整的DX12 Ultimate API。综合目前的消息来看，“Meteor Lake”可能将成为英特尔的一个突破性的平台，为使用Windows系统的笔记本电脑带来全新的体验，还是非常值得期待的。'
      ]
    },
    {
      id: 9,
      time: {
        year: '2023',
        month: '06/29'
      },
      name: 'AMD MI300X单GPU可运行800亿参数模型',
      detail: '6月13日，AMD举办的“AMD数据中心与人工智能技术首映会”上，公布了外界期待已久的数据中心APU(加速处理器)Instinct MI300的更多细节和更新。',
      html: [
        'AI浪潮中，整个市场对于算力的巨大需求，让NVIDIA(英伟达)成为了最大受益者，A100等加速卡供不应求。面对如此大的蛋糕，显然其他厂商也不会坐以待毙，作为GPU领域英伟达最有力的竞争者之一，AMD带来了自己的方案。',
        '6月13日，AMD举办的“AMD数据中心与人工智能技术首映会”上，公布了外界期待已久的数据中心APU(加速处理器)Instinct MI300的更多细节和更新。',
        '据AMD CEO苏姿丰的介绍，AMD的Instinct MI300A是全球首款针对AI和高性能计算(HPC)的加速处理器，作为市场上首款“CPU+GPU+内存”的一体化产品，MI300A拥有13个小芯片，其晶体管数量高达1460亿个。它采用CDNA 3 GPU架构和24个Zen 4 CPU内核，配置128GB的HBM3内存。相比前代MI250，MI300，在AI上的算力(TFLOPS)预计能提升8倍，能耗性能(TFLOPS/watt)将优化5倍。',
        {
          img: require('@/assets/images/news/news_17.jpg')
        },
        '同时，AMD还推出l了一款GPU专用的MI300，即MI300X，该芯片专为大型语言模型和其他尖端AI模型设计，拥有192GB的HBM3内存、5.2TB/秒的带宽和 896GB/s的Infinity Fabric 带宽，晶体管数量达到1530亿个，而目前AI模型常用的英伟达H100仅有800亿个晶体管。',
        'AMD称，MI300X提供的HBM密度最高是英伟达AI芯片H100的2.4倍，其HBM带宽最高是H100的1.6倍。发布会上，苏姿丰以Hugging Face AI模型进行了演示，这个大语言模型在现场写了一首关于旧金山的诗。单个MI300X即可运行一个800亿参数的模型，这是首次在单个GPU上运行这么大的模型。苏姿丰指出，模型尺寸越来越大，你实际上需要多个GPU来运行。随着AMD芯片上内存的增加，开发人员将不需要那么多GPU，可以节省成本。',
        '除了MI300芯片，AMD还发布了AMD Instinct平台，将8个MI300X加速器组合在一个系统中，采用行业标准OCP设计，提供总计1.5TB的HBM3内存。英伟达和谷歌也已经开发出类似系统，将8个或更多GPU组合起来用于AI应用。',
        '据AMD透露，MI300A现已开始提供样品，MI300X和Instinct平台将在今年三季度提供样品，四季度正式推出。'
      ]
    },
    {
      id: 8,
      time: {
        year: '2023',
        month: '01/29'
      },
      name: '存储器灵活性是FPGA设计的关键',
      detail: '采用FPGA的嵌入式设备领域比汽车行业更加广泛和深入，因此对这些设备而言，能够利用各种不同类型的组件尤为重要。',
      html: [
        '虽然科技界大多关注最新的前沿技术进展，但事实上，很大一部分半导体设备还在使用好几年前的组件。例如，汽车行业最近面临的一些挑战主要集中在制造工艺相对落后的芯片上。采用FPGA的嵌入式设备领域比汽车行业更加广泛和深入，因此对这些设备而言，能够利用各种不同类型的组件尤为重要。在某些情况下，采用FPGA的设备会使用一些最新技术，但另一方面，它们可能使用的是20年前的芯片。',
        '对嵌入式设备的设计人员来说，存储器技术的选择是特别重要的一个方面。许多现代FPGA都设计了一定容量的SRAM（静态随机存取存储器），方便某些算法或其他嵌入式软件在FPGA内运行。但在许多应用中，工程师需要将它们与各种类型的外部DRAM（动态RAM）连接，从而实现特定设备或应用所需的功能。例如，在基于图像传感器的设备中，对高分辨率视频信号进行实时AI处理，以执行诸如识别不同动作类型的任务，就需要使用DRAM来实现输入信号的帧缓冲。',
        '外部存储器的问题在于，存储器类型太多，性能特征、容量、功耗等千差万别。因此，能够连接尽可能多的不同类型的存储器至关重要。当前最常使用的一种是LPDDR4（第四代低功耗双倍数据速率存储器），它为设计人员提供了各种不同容量/密度、速度和功率规格，便于匹配他们开发的特定应用。由于其低功耗特性，它特别适用于移动设备和其他电池供电的设备，也可用于开发工业/汽车中的低功耗设备，以及散热管理颇具挑战性的应用。',
        {
          img: require('@/assets/images/news/news_16.jpg')
        },
        '尽管LPDDR4的规范最初发布于2014年（LPDDR5规范于2019年推出），但由于其灵活性和较低的成本，它仍然广受设备设计人员的欢迎。鉴于其最佳的功耗、成本和电源寿命，LPDDR4如今是工业和嵌入式系统中最受欢迎的DRAM。此外，与较早发布但仍普遍使用的LPDDR2和LPDDR3类型的存储器相比，LPDDR4提供了功耗和性能方面的重大改进。因此，像美光（Micron）这样的内存公司提供了大量不同类型的LPDDR4器件，以满足市场的不同需求。',
        '作为小型FPGA市场现代化战略的一部分，Lattice最近推出了CertusPro™-NX 系列产品，这是目前同类产品中唯一支持LPDDR4的FPGA系列。因此，工程师现在不仅能够利用速度更快的器件，还能兼顾低功耗和低频率，这对嵌入式设备至关重要。这种组合令人振奋之处在于，它能够为更广泛的设备提供强大的功能，例如机器视觉和其他基于智能摄像头的应用。尤其是现在可以将AI功能引入更小、更便宜和更低功耗的设备，从而扩展这种强大新技术的应用范围。',
        '从Micron这样的内存制造商角度来看，在更多主机或处理器件（如CertusPro-NX FPGA）中更广泛地支持 LPDDR4，意味着该公司将拥有更多的客户，可以向他们销售其内存产品。对于设备设计人员来说，新增LPDDR4支持意味着他们可以从这些成熟的主流内存技术的广泛长久应用中受益，因为这些器件制造生命周期很长，能获得长期稳定的供应。',
        '最后，我们需要认识到嵌入式设备的世界持续以惊人的速度增长和多样化发展。因此，当组件选择的范围和互连方式不断扩大发展时，对所有相关方都是真正的多赢。LPDDR4存储器与FPGA的组合显然可以实现广阔的应用，可以专门针对各种不同的环境开发应用。对于希望提高灵活性的设备设计人员而言，这无疑是一个激动人心的新时代。'
      ]
    },
    {
      id: 7,
      time: {
        year: '2022',
        month: '09/29'
      },
      name: '为何说10BASE-T1S是汽车通信中缺失的以太网链路',
      detail: '新的IEEE汽车以太网标准不断涌现，10BASE-T1S以太网是最新标准之一。本文讨论汽车行业的发展趋势，它们反映了汽车电子/电气(E/E)架构的变化，以及新10BASE-T1S标准如何支持和推动这种新架构的部署。',
      html: [
        '汽车行业目前正在经历大变革。汽车制造商需要快速针对几个大趋势提供解决方案，例如个性化、电气化、自动化和全面互连。OEM需要彻底改变他们的E/E架构，以支持新功能。虽然这种变革带来了重大的技术挑战，但也为OEM提供了机会，让他们开始考虑在E/E架构中不再使用基于独立域的解决方案，因为随着一代平台发布，此类解决方案随着控制模组的不断增加而变得笨重不堪。在架构发生这种重大改变后，OEM可以集中精力开发更出色的技术解决方案，同时通过汽车个性化、销售服务和无线(OTA)升级等功能增加售后收入。该行业正在转向一种常见的新架构，通常被称为区域架构，并希望利用其他行业（特别是IT行业）的技术和经验，使汽车成为车轮上的计算机。',
        '区域架构按实际的物理位置，而不是按功能来决定连接，基于独立域的架构属于后者（按功能来决定连接）。这种改变大大减少了汽车中的电子控制单元(ECU)的数量，并且让线缆总长减少达1 km。其次，它让硬件和软件解耦，提供以服务为导向的架构(SOA)。许多OEM都开始大力投资软件自主研发，希望能够提供端到端解决方案，以简化平台集成，提供更多跨职能的功能。这种可扩展的软件平台方法可以最大限度减少设计变更，增加新的收入来源，帮助减少长期的研发投资，缩短开发周期，同时支持多个车型系列。',
        '这些革命性的架构变革带来了很多挑战，促使许多OEM对整个组织进行重组，从各个部门各自负责特定独立域功能控制器，转向集成度更高的跨职能组织。汽车正快速成为使用以太网设备的主要领域，在汽车中广泛部署以太网则成为成功推出这些新架构的关键基础之一。以太网带来了所需的扩展能力，支持多种速率等级，是一种成熟可靠的传输媒体，支持基于服务的架构，采用充分开发的安全和防护构建模块。以太网采用定义明确、易于理解的OSI模型，能够更轻松的管理整个车辆的复杂网络。',
        {
          img: require('@/assets/images/news/news_13.jpg')
        },
        '虽然可以利用其他行业的许多以太网基本概念，但汽车E/E架构有一些独特的需求，因此需要开发新技术。对于汽车，一个关键因素就是减轻汽车的重量，这会直接影响到汽车的行驶里程。如今使用的电缆线束是汽车中最重的三个子系统之一（重达60千克）。传统的以太网电缆使用四个差分对进行数据传输，这会增大汽车的重量和布线复杂性，对汽车应用来说不是最佳选择。为了解决这一问题，开发了新的IEEE标准，支持通过单对双绞线进行以太网传输，此外，还通过区域架构缩短线缆线束的长度，以显著节省线缆成本并减轻重量。',
        '随着基于区域的架构概念不断发展，为了充分利用这种新架构的优势，显然需要将以太网连接扩展到终端传感器和驱动器。现有的传统连接技术（例如FlexRay和CAN）通常要求在网关中实现协议转换，这可能导致成本、复杂性和延时增加。现有的汽车以太网技术（例如100BASE-T1）需要使用点对点交换连接，无法满足支持终端连接应用向以太网过渡的系统成本要求。所以，IEEE呼吁提供解决此问题的方法。一些关键要求包括：',
        '实现比现有技术更快的通信速度；例如，CAN(FD)',
        '取代FlexRay等传统车载网络技术',
        '如果使用100BASE-T1连接ECU不经济高效，则需要100BASE-T1的替代方案',
        '能够支持简单、冗余的传感器网络连接',
        '10BASE-T1S规范是IEEE 802.3cg标准的一部分，于2020年2月发布。10BASE-T1S提供汽车以太网生态系统中缺失的一环，支持真正的以太网到边缘连接，并满足区域架构的需求。10BASE-T1S与其他汽车以太网技术不同的一个独特之处：它支持多点拓扑结构，所有节点都通过同一对非屏蔽双绞线连接。这种总线配置提供一个优化的BOM，只需在每个节点上部署一个以太网PHY，无需采用与其他以太网技术关联的切换或星型拓扑。该标准规定必须支持至少8个节点（可以支持更多节点），总线长度必须达到25米。',
        {
          img: require('@/assets/images/news/news_14.jpg')
        },
        '该标准的另一个新特点是物理层冲突规避(PLCA)，顾名思义，就是避免共享网络上发生冲突。这种配置确保确定性最大延时主要由网络的节点数量和要传输的数据数量决定。每个节点都会获得传输机会。如果彼时一个节点没有数据要传输，它会将传输机会移交给下一个节点，以充分利用可用的10 Mbps带宽。',
        '由于它是交流耦合系统，所以也支持10BASE-T1S网络供电。这样可进一步节省电缆，减小连接器的大小，并因电缆节省和连接器复杂性降低而实现更高的可靠性。数据线供电标准化(PoDL)可用于点对点配置，目前作为IEEE标准改进的一部分，也支持多点拓扑。',
        '10BASE-T1S在汽车领域的应用广泛多样，多种传感器和驱动器在车身领域、舒适性、信息娱乐以及ADAS系统中的跨多个功能应用仍在探讨中。',
        '汽车E/E架构正在经历一场重大变革。向区域E/E架构过渡迫在眉睫。10BASE-T1S提供缺失的链路，通过优化的以太网到边缘连接支持这种过渡。在这个部署过程中，仍然需要克服一些问题，例如以太网连接会增加模块实施方案的元件成本和复杂性。10BASE-T1S通过降低系统成本，以及提供多种支持不同类型的信号链分区的产品选择来解决这些问题。ADI公司积极参与标准化活动，并与OEM密切合作，以积极推动10BASE-T1S的推广和部署，确保满足他们的系统要求。',
        {
          img: require('@/assets/images/news/news_15.jpg')
        }
      ]
    },
    {
      id: 6,
      time: {
        year: '2022',
        month: '03/22'
      },
      name: '英伟达首款5nm GPU曝光：用于数据中心的H100 Hopper',
      detail: 'NVIDIA GTC 2022春季开发者大会在3-22晚间召开，而外媒VideoCardz 却抢先分享了英伟达下一代 GPU 的详细爆料。',
      html: [
        'NVIDIA GTC 2022春季开发者大会即将在3-22晚间召开，而外媒VideoCardz 却抢先分享了英伟达下一代 GPU 的详细爆料。VideoCardz称英伟达即将推出的 Hopper H100 GPU 将采用台积电 5nm 工艺，且大型单芯片内将容纳多达 144 组 SM（流处理器）单元。',
        '从H100加速计算卡的渲染图上可以清晰地看到8组GPC(图形处理集群)，事实上如果放大慢慢数，可以确认144组SM，也就是对应18432个CUDA核心，相比于Ampere架构大核心GA100 6912个多出足足1.67倍。而根据昨日消息，8组GPC中只有一组开启3D图形引擎，毕竟这是计算卡。图中还可看到英伟达在 Hopper H100 GPU 核心附近配备了六枚 HBM 显存（类似英特尔 HL Gaudi 2），推测最低容量为 48GB（HBM3 理论可达 96GB+）。',
        {
          img: require('@/assets/images/news/news_10.jpg')
        },
        '此外 WhyCry 指出，英伟达也会推出面向服务器平台的标准化产品，其中包含了多款基于 GH100 GPU 的 SKU，比如适用于 DGX 主板（SXM）、工作站、以及 SuperPod 的版本。',
        '详细规格方面，假如 Hopper H100 GPU 与上一代 Turing 架构的规格保持一致，那每组 SM 单元或正好有 64 个 CUDA 核心 / 总计 9216 个。若 GPU 主频为 2.2 GHz，推测双精度性能在 40 T-Flops 左右。Ampere A100。',
        {
          img: require('@/assets/images/news/news_11.jpg')
        },
        '这也是NVIDIA第一个5nm工艺的GPU，仍然坚持单芯片设计，预计核心面积900平方毫米左右，功耗可能达到500W，另外预计还有双芯封装的GH202。',
        {
          img: require('@/assets/images/news/news_12.jpg')
        },
        '至于真相究竟如何，还请耐心等待英伟达 CEO 黄仁勋在 GTC 2022 主题演讲期间披露。本次大会上，NVIDIA应该还会推出基于Hopper GH100核心的工作站、个人超级计算机等相关产品，甚至可能会公布PCIe接口样式的H100计算卡。'
      ]
    },
    // 2021 年
    {
      id: 5,
      time: {
        year: '2021',
        month: '09/21'
      },
      name: '6G：脱离现实的炒作？',
      detail: '尽管6G预计在十年之后才开始商用，但研究工作已经全面启动。这些研究确定了6G将基于何种技术，以及将有哪些应用。',
      html: [
        '6G无线技术的宣传逐渐声势浩大。这场6G的狂欢前所未有地开创了提前宣传新技术的纪录——现在连底层的6G基础设施都尚未到位。',
        '诺基亚贝尔实验室核心研究部总裁Peter Vetter指出：“尽管 6G预计在十年之后才开始商用，但研究工作已经全面启动。这些研究确定了6G将基于何种技术，以及将有哪些应用。”',
        {
          img: require('@/assets/images/news/news_78.png')
        },
        '必须先制定标准，然后再设计芯片。”诺基亚CX战略和技术副总裁Hilary Mine指出。Mine预计韩国将于2028年左右开始部署6G，但她同时指出，欧洲和北美的部分地区也希望能够抢先部署这项无线技术。几乎所有Nokia高管都认为，2030年是进行6G商业部署的一个切实可行的时间点。还有差不多十年的时间，实现这个预测的可能性相当大。',
        '要知道，新冠疫情仍对全球产生很大影响。3GPP 5G会议已经因疫情而推迟，这打乱了部分5G部署的实施计划。下一个5G标准更新版本R17原本计划在9月“冻结”的，现在已推迟到2022年第二季度了才能完成了。',
        '现在只要再出现新的新冠病毒变体，就可能再次破坏5G部署的时间表，使6G部署时间表成为空谈。',
        'NYU Wireless 创始人 Ted Rappaport 预计，通过对5G蜂窝网络基础设施进行升级而使其密集化，可以为6G带来长久的好处。 “一旦世界各地的5G网络更加密集，在5G基础上的6G和之后的网络也就更密集。” Rappaport说。他补充说，目前毫米波和中频段5G的密集化将加速6G基础设施的建设。 “这些处于更高频率的自适应天线技术能够以更高的增益克服噪声。事实上，它抵消了人们注意到的更高频率下的功耗。”他说。Rappaport是5G毫米波技术的拥趸，因而也热衷于6G高频通信技术。',
        '3G和4G频谱的重新利用可能会成为已发布的2030年6G部署时间表中的一个问题。现有的低频段频谱资源有限，可能会被大量新的物联网设备占用。诺基亚的Peter Veeter表示，6G传感器等应用需要低频段频谱。另外，5G非地面网络对6G也很重要。',
        '纽约大学无线技术研究人员预测，6G需要使用100GHz以上的频率，达到亚太赫兹范围。Rappaport预计6G的数据速率可达数十至数百Gbps，延迟却低于1ms，这对于实现传感应用及高数据速率十分重要。“很多人现在还不明白这一点，但他们会明白的。” Rappaport预言。较高频段的毫米波（90GHz及以上）和太赫兹无线电的微小波束可以实现6G传感与定位，其应用前景广阔。如果波束的频率更高，那么6G手机或其他未联网设备在提供普通语音通信的同时也能感知雷达信号。',
        '在工业、自动驾驶、显微手术等应用中，使用太赫兹传感技术可以获得更精确的定位。远程手术早在2001年就已出现，用于解决偏远落后地区距离遥远及外科医生缺乏的问题。不过，这样的系统可不便宜。Joe Namath不太可能现在就在其医疗保险广告中宣传远程手术。（注：Namath是伟大的橄榄球四分卫，人们喜欢的体育偶像常为私人医疗计划做代言。但大多数国家都不会通过有线电视广告销售医疗保健服务，而许多国家甚至提供公共医疗保健！）',
        '迈向6G的关键是发布5G-Advanced规范，3GPP将于2023年底冻结该规范的R18版本，并于2025年将其用于商业网络。升级的5G自然会提供更高的数据速率和更低的延迟，移动宽带也会增加，可以支持增强现实（AR）和虚拟现实（VR）等新兴应用。事实上，供应商已经为AR/VR创造出一个新名词：扩展现实（eXtended Reality），即XR。观察家们预测，XR眼镜甚至可以取代（至少补充）智能手机，我们将拭目以待。',
        '在R18版本中，RedCap（Reduced Capability，轻量级5G）在可穿戴设备和其他物联网设备中的应用也将得到扩展。最初的RedCap功能是在R17版本中规定的，但R18中增加了关键的物联网功能，例如设备定位，用于实现资产跟踪。这是分阶段发布的一部分，以便使5G至少适合一部分IoT应用。',
        '上述5G规范将在2025年开始推出，预计6G也将在2030年首次亮相。在6G登场之前，我们可能会看到一些标榜为6G但实际上并非6G的网络。或者说，伪6G会出现。我们对伪4G和伪5G都不陌生，所以，伪6G不足为奇！'
      ]

    },
    {
      id: 4,
      time: {
        year: '2020',
        month: '10/30'
      },
      name: 'Credo公司的光通信产品如何解决5G和数据中心痛点',
      detail: '这次Credo新品发布会是业界少有的一次推出5颗芯片，从5G无线通信网络建设的前传/中传连接方案Seagull 50，到为服务数据中心网络平台打造的Dove系列，这些新品满足了对成本、功耗、性能以及上市时间与产能等多方位需求。',
      html: [
        '目前，5G技术处在应用前期，从芯片到通信设备厂商，从运营商到5G应用，车联网、无线医疗、AR/VR、无人机（媒体、物流）、社交网络的高清直播、个人AI辅助、智能制造、智慧城市及智能建筑，还有家庭娱乐中的超高清8K视频/云游戏等等整个行业呈现蓬勃发展态势。',
        '为了满足5G的上述应用场景，需要更大的传输容量和更快的传输速率支持，5G设备所用的光器件模块需要进行相应升级从而带来海量光器件需求。另外，提高设备性能、降低5G成设备本及功耗是业界面临的主要挑战。由此可以看出，5G网络面临“提速”“降费”的巨大压力。于是，Credo的Seagull 50芯片应运而生，它是一款完美匹配5G无线通信严苛要求的高性能DSP。它满足了移动网络不断攀升的带宽需求，与可与多种Driver及TIA互联互通，支持长距离传输及工业级工作温度范围。可实现SFP56光模块1.5W的功耗目标及QSFP28光模块2W的功耗目标。',
        {
          img: require('@/assets/images/news/news_05.jpg')
        },
        '面对已经到来的、以5G与大数据中心等为核心的“新基建”时代，满足了5G设备光模块所需的高性能、高速率、宽温度、低成本的光通信芯片，只是满足了今天庞大的数据流动需求的一部分。5G与云服务每日都在进行海量数据的产生、处理、交换、传递，对数据中心提出了更高的要求，数据量的暴增必然会对网络带来挑战。根据思科预测，2020年中经由IDC处理的数据流量占全球产生流量的比例为99.35%，流量的暴增迫使数据中心规模不断扩大，带宽不断提升。因此，数据中心也驱使光模块不断升级，同时数据中心光模块同样面临着性能、功耗、成本三大挑战。',
        '关于数据中心光模块面临的挑战，Credo销售副总裁杨学贤具体分析到，“首先，数据中心对光模块性能和可靠性要求很高，若出现故障、宕机等情形，重则严重影响社会的经营生产及日常生活。其次，电力成本也是IDC运营成本中占比最高的部分，大约占运维成本的60%左右，光模块功耗过高会增加数据中心的电力消耗和制冷成本。另外，根据IDC和ODCC数据，我国2019年IDC行业规模为1600亿元，同比增长约25%。其中光模块/有源光缆（AOC）占其中3.2%，约52亿元市场规模。”',
        '能同时解决以上三大挑战的光通讯芯片非常少。于是，Credo凭借其自有DSP技术和均衡技术，专为下一代100G/200G/400G数据中心网络平台一口气打造了四颗光通信DSP：Dove 100、Dove 150、Dove 200及Dove 400。它们可用于数据中心所有基于光纤的连接。这几款DSP均在性能、功耗、成本三个维度进行了优化，以满足新基建背景下数据中心建设对光模块的海量需求。',
        {
          img: require('@/assets/images/news/news_06.jpg')
        },
        '这次Credo新品发布会是业界少有的一次推出5颗芯片，从5G无线通信网络建设的前传/中传连接方案Seagull 50，到为服务数据中心网络平台打造的Dove系列，这些新品满足了对成本、功耗、性能以及上市时间与产能等多方位需求。',
        '去年在中国国际光电博览会开展之际，Credo宣布HiWire有源电缆（AEC）量产供货，同期也宣布了HiWire 全球产业联盟的成立。HiWire全球产业联盟是支持和发展短距离超高速连接线缆AEC（有源电缆 Active Electrical Cable）连接标准的非营利性组织。HiWire全球产业联盟通过促进开发高质量、可兼容的HiWire AEC设备，提高公众对HiWire AEC解决方案的了解与认知，促进终端用户对HiWire AEC的产品需求，进而构建和发展真正即插即用的，多源且可靠的有源电缆AEC生态系统。经过一年的发展，现拥有联盟成员近四十家。微软、腾讯等都是联盟成员。',
        'Credo究竟是IP公司还是芯片公司？是否是美国公司？Credo、默升和芯境究竟是什么关系？在Credo产品发布会之前，其集团首席运营官特别助理及资本市场部总经理陈冉介绍了公司发展的三个阶段：Credo 1.0阶段，Credo 阶段。2008年三名海归华人创始人靠自己的信念在中国创建了Credo，从此为中国培养了一批从事全世界顶级速率Serdes 研发的队伍和团队。Credo在2008年至2014年，靠创始人的自有资金和创始团队的强大信念踏踏实实在做高速通讯芯片研发。2012年演示了65nm 28G NRZ Serdes Phy，2014年又演示了40 nm 56G NRZ Serdes Phy。',
        'Credo 2.0阶段，陈冉称之为默升阶段。这一阶段在集团CEO的带领下，将公司先进的技术和卓越性能的芯片产品逐渐转化为实实在在的订单。在SerDes IP领域，Credo拥有全球最大最全的SerDes IP产品组合，而且拥有全球最广的SerDes IP客户群，进入了全世界最顶级的数据中心、云计算、大数据、5G、人工智能、自动驾驶等应用领域。智能、自动驾驶等众多应用领域的行业顶级客户。在交换机芯片，Credo依托高管团队超过20年的行业经验及世界一流客户的鼎力支持，通过5年研发和打磨，其现有的线卡28nm Serdes芯片出货量已超过200万颗，适时推出了Mac Sec加密芯片并支持国标；在光芯片 并支持国标；在光芯片DSP领域经过三年的积累于2020年9月8日一口气发布了5款光通信DSP。',
        '公司的3.0阶段，陈冉称之为芯境，芯境科技（上海）有限公司成立于2018年，专为中国客户提供更及时周到的售前与售后服务，以支持中国系统厂商的快速发展。从以上三个阶段的发展来看，Credo的经营方针从早期起的IP业务为主转为现在的芯片、AEC等多元化产品线的长期可持续发展战略。从其成长历程我们已经清楚了Credo不是一家美国公司，他是成长于中国的，服务全球客户的国际化公司。目前Credo产品和业务如下图：',
        {
          img: require('@/assets/images/news/news_07.jpg')
        },
        '“Credo虽然是全球屈指可数能在28nm/16nm/12nm/7nm全部工艺基础上实现400G/800G连接商业解决方案的公司，但他不依赖最先进的工艺节点。这点早在2017年Credo首次成功公开演示100G PAM4就已证明，当时其采用28nm制程取得了令人瞩目的成就。”Credo销售副总裁杨学贤向《电子工程专辑》记者表示，“业内其他竞争对手往往必须采用更先进的工艺制程才能实现Credo产品相同的速率与功耗，因而需要承担更高的成本。”'
      ]
    },
    {
      id: 3,
      time: {
        year: '2020',
        month: '09/15'
      },
      name: '我国《6G无线热点技术研究白皮书》（2020）发布',
      detail: '比起 5G，6G 数据传输速率有 50 倍提升，理论网速可达 1TB/s，且延迟最高低至十分之一秒。目前 5G 可广泛应用物联网、工业物联网、车联网等领域，能帮助边缘运算、机器学习、医疗、能源和智能城市等行业获得新的进展。',
      html: [
        '移动通讯发展向来遵循“使用一代、建设一代、研发一代”规律。使用 3G 时，4G 正在研发；用 4G 时，5G 箭在弦上。因此 5G 方兴未艾，6G 就已紧锣密鼓研发了。6G 是第六代移动通讯标准（6th generation mobile networks），也称为第六代移动通讯技术，目前看来是相对 5G 的概念名称。',
        '比起 5G，6G 数据传输速率有 50 倍提升，理论网速可达 1TB/s，且延迟最高低至十分之一秒。目前 5G 可广泛应用物联网、工业物联网、车联网等领域，能帮助边缘运算、机器学习、医疗、能源和智能城市等行业获得新的进展。专家称如果 5G 是开启万物联网的大门，那么 6G 将达成万物智慧联网。比 5G 更高的速度、更低延迟和更广的连接范围，6G 更能应用毫米波、太赫兹等高频资源，与人工智能技术结合，创造更多连接。',
        'A2019 年以来，广东省新一代通信与网络创新研究院（粤通院）联合清华大学、北京邮电大学、北京交通大学、中兴通讯股份有限公司、中国科学院空天信息创新研究院共同开展了 6G 信道仿真、太赫兹通信、轨道角动量等 6G 热点技术研究。在此基础上，研究团队与中国联合网络通信有限公司对 6G 无线通信新技术的现状和后续发展方向及产业化能力进行延续评估并提出思考，并推出《6G 无线热点技术研究白皮书》（2020），为 6G 未来的研究提供参考和支撑。',
        {
          img: require('@/assets/images/news/news_04.jpg')
        },
        '目前，随着各国及产业界 6G 研究的推进，6G 通信的愿景，场景和基本指标均已有了新的进展。相比于现行的 5G 通信，6G 通信网络将与云计算、大数据和人工智能进一步集成。同时，为解决未来高度智能、高度数字化和高度信息化社会对无线传输的需求，6G 无线网络在无线连接的维度、广度都将有巨大的提升，支持诸如超大带宽视频传输，超低延时工业物联网，空天地一体互联等诸多场景。',
        '为支持上述愿景和应用，6G 通信系统的性能要求必须实现如 1Tbps 超大峰值速率和 1Gbps 超大用户体验速率，超低延时 0.1ms 和高移速通信，超高频谱利用率等。为了支持极高的峰值速率，支持的最大接入带宽必须大幅增加。毫米波频段可支持高达 10 GHz 的带宽，而太赫兹和可见光频段可达 100 GHz。激光、可见光通信和太赫兹波段通信是 6G 研究的主题。',
        '白皮书提到，6G 将完成 “海量物联”和 “万物智联”，打造陆海空天融合通信网络，在陆地、海洋和天空中都会有大量的互联终端设备。利用这些数以亿计的传感器的实时感知与智能计算能力，支持多终端共享 AI 算力，智能终端设备侧 AI 也必将从单设备、多设备正式走向分布式和去中心化模式，为 6G 的异构、多终端实时感知计算提供了有力的支持。6G 网络将基于无处不在的大数据，将 AI 赋能各个领域的应用，创造出 “智能泛在”的世界。6G 将进一步超越 5G 时代的边缘计算，走向 “在网计算”，进而为 “泛在智能”提供算力基础，算力将从外延走向内生，最终实现网络与计算的深度融合。',
        '本白皮书围绕上述愿景，对 6G 无线通信中各热点技术的应用和发展进行了梳理。白皮书全文请查看以下链接。https://www.txrjy.com/thread-1146215-1-1.html'
      ]

    },
    // 2018 年
    {
      id: 2,
      time: {
        year: '2019',
        month: '02/15'
      },
      name: '一秒传输130TB数据，我国光纤研发获突破',
      detail: '随着数据通信呈现爆炸式增长，对现有的基础网络产生巨大的压力。三超光传输将更好地缓解数据传输压力，为迎接5G时代的到来做足准备。',
      html: [
        '自移动互联网崛起后，我们似乎已经很少关注有线网络的发展情况。在移动互联网方面我们知道，全行业都在等待5G的到来，到时候移动网络下载幅度有望达到1GB每秒的速度。在有线网络的建设方面，实际上发展也是非常快的，只不过多数顶级有线网络都是企业用途，一般消费者很少接触到。',
        '根据人民日报消息，中国信息通信科技集团方面表示，我国光通信技术再次取得突破性进展，首次实现了速度高达1.06Pbit/s的超大容量单模多芯光纤光传输系统实验，可以实现一根光纤上近300亿人同时通话,标志着我国在“超大容量、超长距离、超高速率”光通信系统研究领域迈向了新的台阶。',
        '如果换算为我们熟悉的数据单位或许你会更容易了解这一技术的厉害之处，据说该网络的速度之快达到了每秒130TB，意味着如果不考虑硬盘读写速度的话，你可以在一秒内将世界上任意一个文件下载完成。专家指出，这是我国首次实现如此“超大容量、超长距离、超高速率”的试验，已经达到了国际先进水准。',
        {
          img: require('@/assets/images/news/news_03.jpg')
        },
        '据介绍，本次实验采用的传输介质是一种单模19芯的特种光纤，为我国自主研制，相比此前单模7芯光纤，传输能力大为增强，传输容量是目前商用单模光纤传输系统最大容量的10倍，可以在1秒之内传输约130块1TB硬盘所存储的数据。相比2017年实现的560Tb/s光传输系统实验,容量几乎倍增。在材料上,本次实验采用的是我国自主研发的硅基材料芯片，而不是传统的三五族材料芯片。',
        '该系统设备在C+L波段内产生了375个光载波,基于硅光相干收发芯片实现了25GHz通道内的178.18Gbit/s DFTs-PDM-16QAM信号光收发,在单模19芯光纤内完成了光传输验证,谱效率达到了113bit/s/Hz，传输总容量达到1.06Pbit/s,首次实现了从“Tb/s级”到“Pb/s级”的突破。',
        '据光纤通信技术和网络国家重点实验室贺志学博士介绍，随着数据通信呈现爆炸式增长，对现有的基础网络产生巨大的压力。三超光传输将更好地缓解数据传输压力，为迎接5G时代的到来做足准备。不过需要注意的是，这一测试是在实验室中完成的，意味着距离实际商用还有一段距离。再者，这种高速传输技术一般也不会应用到民用领域中，多为跨国企业跨海传输数据所用。',
        '同时我们也留意到，人民日报表示这是“达到了国际先进水平”，言下之意在国际社会上还有更先进的技术。实际上据我们查阅资料得知，在当下的水平下，最快的光纤传输速度可以达到160TB每秒，并已经在商用。看来在科技上始终是一山还有一山高，科研工作者还需要继续努力。',
        '随着科技的发展，人类社会诞生的数据总量也越来越多，因此我们对高速网络的需求也更加迫切。同时，高速网络也是国家军事、安全的需要，未来还会继续快速发展。'
      ]

    },
    {
      id: 1,
      time: {
        year: '2018',
        month: '12/23'
      },
      name: 'Wi-Fi 6准备进军智能工厂应用',
      detail: '产业组织无线宽带联盟(Wireless Broadband Alliance，WBA)准备在英国一座飞机零件制造厂展示利用最新802.11ax 标准Wi-Fi设备的自动化营运优势，这是该技术几个准备在今年展开的试营运计划中的第一个，将在市场上与5G蜂巢式技术阵营较劲。',
      html: [
        '产业组织无线宽带联盟(Wireless Broadband Alliance，WBA)准备在英国一座飞机零件制造厂展示利用最新802.11ax 标准Wi-Fi设备的自动化营运优势，这是该技术几个准备在今年展开的试营运计划中的第一个，将在市场上与5G蜂巢式技术阵营较劲。',
        'WBA的成员将为拥有70年历史、位于英格兰伍斯特郡(Worcestershire, England)的商用/军用飞机零件制造商Mettis提供免费设备，目标是展示一些利用又被称为Wi-Fi 6的802.11ax Wi-Fi技术之自动化营运应用案例优势。有一个由英国政府支持、将在英格兰中部地区进行的计划，将赞助几个利用5G蜂巢式技术的试营运项目；WBA则准备要在世界各地展开至少4个利用Wi-Fi技术的试营运项目，「因为在英格兰中部地区已经开始了5G试营运，我们就与英国政府部门接洽，分享了我们利用异质网络(heterogeneous networks)的愿景，他们也同意了；」WBA总经理Tiago Rodrigues接受EE Times采访时表示：「所以我们谈到在5G大计划下测试Wi-Fi 6的想法，Mettis正在考虑采用5G，但他们也很积极研究Wi-Fi技术。」',
        '这显示了5G与Wi-Fi技术阵营在工业物联网(IoT)以及其他应用场景越来越多的竞争；这两种技术都认为它们在传输速率与延迟性方面的演进，能实现传感器的无线连结，以简化工厂生产线维护与机器人布署。长期看来，终端使用者可以预期有「混合式」的无线网络可使用；但短期之内，最新的5G以及Wi-Fi网络还是会在它们的潜在优势上相互较劲，而且通常是利用类似的应用案例。对终端使用者来说，这种竞争有助于推动传统制造工厂的数字化转型。',
        '举例来说，有一座Bosch的工厂已经藉由5G试营运看到在生产力上的提升；在美国，电信业者AT&T最近则宣布了一项交易，作为其试营运计划的一部分，将为三星(Samsung)位于美国德州奥斯汀(Austin)的晶圆厂提供免费5G服务。英格兰中部地区技术项目的负责人Mark Stansfield表示：「我们最近宣布在伍斯特郡展开第一个5G工厂的试营运，这是我们推动智慧工厂的一个里程碑；而同时能看到全世界第一个Wi-Fi 6工业物联网试营运在同地区展开，非常令人欣慰。」包括British Telecom、Broadcom、BSG Wireless、CableLabs、Cisco、HPE Aruba与Intel等公司，将为Mettis厂房的Wi-Fi 6试营运提供所需设备与专业技术支持；WBA的Rodrigues表示，该组织将与Mettis合作，定义并布署一些准备在今年稍晚进行的测试，并预计在明年1月报告测试结果。',
        {
          img: require('@/assets/images/news/news_63.jpg')
        },
        'Rodrigues表示，除了工厂，「我们还想在其他垂直应用领域进行试营运，包括营运商环境(carrier environments)、运动场或机场等高密度地点，还有地铁、火车站等大众运输系统；我们正在全球各地寻找商机，包括美国的几个运动场以及营运商。',
        'Wi-Fi 6的两个新功能会是测试的重点──该标准添加了流量优先等级(traffic prioritization)的功能，能为选定功能提供确定性的响应；此外该标准支持基础IoT指令语言，可用以唤醒传感器。这些新功能可望实现让系统自动回报紧急维修需求等应用，也能让生产线工作人员透过以传感器实时馈入的扩增实境(AR)显示信息，利用平板装置等工具来维修厂房中的系统。',
        '「Mettis是在几年前决定，他们要让所有的新机器设备配备多种传感器；现在的问题是如何收集数据，以及他们需要哪种接口。」Rodrigues表示：「他们没有任何一种无线连结技术，有一些机器是有线连结，但只有非常小一部分，所以这对他们来说是大挑战；他们在三、四年前尝试过使用较旧版本的Wi-Fi，结果并不令他们满意，但我们有信心Wi-Fi 6能帮上忙。」试营运将会在Mettis占地27英亩厂区的三个或四个地点进行；该公司的厂区有多栋厂房，进行飞机零件的金属熔融、灌模，还有系统组装、涂装与测试。Rodrigues表示：「他们想要尽可能将生产流程数字化。」'
      ]

    },
    {
      id: 0,
      time: {
        year: '2017',
        month: '01/24'
      },
      name: '中国半导体封装产业面临内忧外患',
      detail: '半导体产业的重磅并购近年来已是司空见惯，但如果按照产业环节的来看，就会发现同是半导体，并购却别有天地。制造领域"消无声息"，虽然设计领域也有高通收购NXP、安华高收购Broadcom等重磅收购，但如果和封装领域的"强强联合"来比，就成了小巫见大巫了。近两年来，仅仅封装代工产业前十名里面就发生过全球第一的日月光和全球第三的矽品合并；第四的新科金朋和第六的长电科技联姻；第二的安靠收购了第七的J-device（2014年排名）。前十名里面竟然有三家被并购，一时间，封装代工，变了江山，换了容颜。',
      html: [
        '半导体产业的重磅并购近年来已是司空见惯，但如果按照产业环节的来看，就会发现同是半导体，并购却别有天地。制造领域"消无声息"，虽然设计领域也有高通收购NXP、安华高收购Broadcom等重磅收购，但如果和封装领域的"强强联合"来比，就成了小巫见大巫了。近两年来，仅仅封装代工产业前十名里面就发生过全球第一的日月光和全球第三的矽品合并；第四的新科金朋和第六的长电科技联姻；第二的安靠收购了第七的J-device（2014年排名）。前十名里面竟然有三家被并购，一时间，封装代工，变了江山，换了容颜。',
        '按理来说，"大者恒大、赢者通吃"，半导体产业的前三似乎都可以"闷声大发财"，但此定律似乎对封装企业作用甚微，就算是作为龙头的日月光也并不像台积电和高通一样过着令人"羡慕嫉妒恨"的美好生活，还要"降低身价"收购第三名的矽品。内行看门道。和芯片设计生机勃勃、代工制造热火相反的是，半导体封装业的内忧外患，挑战多多。封装巨头明里联盟结营，实则是抱团取暖的无奈。',
        '不像半导体产业整体的高毛利，封装企业的毛利率、净利率都比较低，企业盈利能力偏弱。排行第六的长电科技并购了第四的星科金朋，上演了"蛇吞象"，看似无限风光，然而长电科技2015年的运营毛利率和净利率却都是负数——"多么痛的领悟"，而日月光的毛利率不到20%，矽品23.52%的毛利率在封装里面竟然"猴子称大王"。而对台积电、高通、IDM代表英特尔而言，毛利率不超过50%，都不好意思说自己是做半导体的。',
        {
          img: require('@/assets/images/news/news_50.jpg')
        },
        '封装企业的利润不堪出手，意味着企业的造血能力羸弱，进而技术更新和新工艺研发难以为继。若更进一步分析这些封测代工企业的财务数据，可以发现这些企业每年能够从营运上得到的现金流，完全无法支应这些公司每年的资本支出及其利润分红，间接说明了这个产业存在着严重的无效率及重复投资的问题，也造成此封装代工负债节节升高的问题，因此这样的产业特性导致现金流紧张，研发开支占比远远低于其他环节的企业，今朝有酒今朝醉，持续发展是奢望。从研发支出占销售额的比重排名来看，矽品、日月光和长电科技稳稳地排在了最后三位，长电科技（研发支出公告为空）利润为负。',
        {
          img: require('@/assets/images/news/news_51.jpg')
        },
        '排名风光，日月光和长电科技实则处境艰难；看起来体量大，全球排名前列，但是盈利艰难，朝不保夕。如果说别的环节的并购"谋发展"，封装企业则是"求生存"。',
        '更加深层的危机在于，产业变革正在悄然临近。为了更好的满足客户的需求，半导体产业的其它环节积极进入封装业。春江水暖鸭先知，台积电早已把触角伸到了高端封装领域，其封装业务已经蔚然成型。台积电挟其在成为2016年AppleiPhone 7 A10应用处理器独家供应商的优势，也就是台积电拥有后段制程竞争力，其具备整合型扇型封装（Intgrated FanOut；InFO），可望持续抢下2017年Apple iPhone8的A11应用处理器代工订单。前车后辙，中芯国际积极布局封装产业，不仅与长电科技成立了合资公司进军封装的bumping环节，更是在今年入股长电，成为其第一大股东。',
        '当Foundry企业的业务逐渐延伸到封装之后，相较于制造而言，封装本身的实力还不足以形成门槛壁垒，Foundry企业则利用其制造的平台，产能紧张的"最强乙方"，为客户提供一条龙的、全方位的技术，这导致封装产业面临着全新的更大的竞争对手。',
        '内忧外患，封装产业能否也进军代工或者设计呢？再选取产业链的龙头企业进行比较，不比不知道，一比吓一跳。即使是封装龙头日月光向上下整合或延伸的难度都很大。作为封装翘楚的日月光，不管是在体现当前赚钱能力的利润率上，还是在未来赚钱潜力的研发上，都被其他厂商甩出了一大截。',
        {
          img: require('@/assets/images/news/news_52.jpg')
        },
        '所以突围不成，那就只有抱团取暖，因此封装代工企业的合并不像其它产业环节的"扩大规模、追求市占率"，若仅只为了市占率而合并，最后却不能增加效率且提升技术的话，最终只会赢了面子却输了底子。从产业环节来看，封测企业藉由合并，减少重复投资，提高利润，将更多资源投入到新工艺的研发，以增加本身的竞争实力，为客户创造更多的价值。如此，预估接下来进行重组并购的封装企业会越来越多，半导体封测行业的合纵连横将会成为"新常态"。'
      ]

    }
  ],
  companyNewsList: [
    {
      time: {
        year: '2025',
        month: '09/24'
      },
      id: 4,
      type: 1,
      img: require('@/assets/images/aboutMe/company_news11.png'),
      name: '坤恒科技发布国产化计算卡系列产品',
      times: '2025-09-24',
      detail: '坤恒科技发布飞腾及瑞芯微计算卡与核心板卡系列产品。',
      html: [
        '坤恒科技发展公司致力于发展高性能计算与可靠数据通信技术与平台，基于自身应用的案例与市场，现对外销售SOC计算卡系列产品与飞腾D2000计算卡系列产品。',
        {
          img: require('@/assets/images/aboutMe/company_news11.png')
        },
        '➣飞腾D2000的核心优势在于强大的扩展能力和多重冗余设计，支持32GB DDR4内存，满足大数据处理需求，并提供3个SATA3.0和1个M.2 SSD接口，支持多种存储组合。',
        '➣产品扩展插槽丰富，可配备1个PCIe*16和2个PCIe*1插槽，可以安装独立显卡和多张采集卡。',
        '--------------------------------------------------------------------------------------------------------------------------',
        '➣作为公司解决方案服务的一部分，可独立出售核心板卡系列产品。',
        '➣敬请联系我们垂询 ---> 电子邮件： info@kun-heng.com'
      ]
    },
    {
      time: {
        year: '2023',
        month: '09/25'
      },
      id: 3,
      type: 1,
      img: require('@/assets/images/aboutMe/company_news07.jpg'),
      name: '坤恒科技对外销售AI GPU卡以及网络加速卡系列产品',
      times: '2023-09-25',
      detail: '坤恒科技对外销售AI GPU卡与网络加速卡系列产品。',
      html: [
        '坤恒科技发展公司致力于发展高性能计算与可靠数据通信技术与平台，基于自身应用的案例与市场，现对外销售GPU卡系列产品与Maxlinear的存储加速卡系列产品。',
        {
          img: require('@/assets/images/aboutMe/company_news07.jpg')
        },
        '➣GPU卡产品经客户验证，性能可靠稳定，可以满足部分应用场合对国产品牌的产品需求。',
        '➣同时公司可以提供AMD MI100、MI210及后续产品系列的产品与技术支持。',
        '--------------------------------------------------------------------------------------------------------------------------',
        '➣作为公司解决方案服务的一部分，现推出基于FPGA的网络传输加速卡与存储加速卡。',
        '➣网络加速卡基于XILINX加速卡产品与MAXLINEAR的加速卡系列产品。',
        '➣敬请联系我们垂询 ---> 电子邮件： info@kun-heng.com'
      ]
    },
    {
      time: {
        year: '2022',
        month: '09/10'
      },
      id: 2,
      type: 1,
      img: require('@/assets/images/aboutMe/company_news05.jpg'),
      name: '坤恒科技推出Expander扩展背板卡系列产品',
      times: '2022-09-11',
      detail: '坤恒科技推出Expander扩展背板卡系列产品。',
      html: [
        '坤恒科技发展公司跟随数字经济时代的脉动，推出SAS Expander扩展背板系列产品（可配机箱出售）。',
        {
          img: require('@/assets/images/aboutMe/company_news05.jpg')
        },
        '产品经客户验证通过性能和兼容性测试，芯片组和产品支持如下功能：',
        '➣硬盘热插拔功能；',
        '➣灯态支持硬盘上电，读写，报错；',
        '➣SPGIO硬盘报错功能；',
        '➣硬盘分时启动；',
        '➣风扇温度控制；',
        '➣BMC支持的IIC接口。'
      ]
    },
    {
      time: {
        year: '2022',
        month: '03/10'
      },
      id: 1,
      type: 1,
      img: require('@/assets/images/aboutMe/company_news04.jpg'),
      name: '坤恒科技乔迁新地址',
      times: '2022-03-10',
      detail: '恭喜坤恒科技北京总部乔迁新地址。',
      html: [
        '坤恒科技发展有限公司在其成立5年的时间里，取得了飞速的发展。因为公司业务发展需要，北京总部搬迁至新地址。',
        {
          img: require('@/assets/images/aboutMe/company_news04.jpg')
        },
        '新办公地址交通便利，紧邻地铁6号线金安桥站，是近几年发展起来的京西轨道交通枢纽的中心。',
        '➣总部地址： 北京市石景山区阜石路与北辛安路交叉口中海时代广场B座808',
        '➣联系电话： 010-69879833 *',
        '➣电子邮件： info@kun-heng.com',
        '请期待和支持坤恒科技的后续发展！'
      ]
    },
    {
      time: {
        year: '2017',
        month: '01/12'
      },
      type: 1,
      id: 0,
      img: require('@/assets/images/aboutMe/company_news01.jpg'),
      name: '坤恒科技对外贸易运营中心成立',
      times: '2017-12-12',
      detail: '坤恒科技（Kun-Heng）在北京成立对外贸易运营中心，为更好的服务本土客户，并同时争取开拓国际市场。',
      html: [
        '自2008年金融危机发生之后,全球的经济贸易形态发生了较大的变化,我国的经济增长步入到一个新的阶段,使得国内对外贸易的市场结构也发生了相应的变化。在中国对外贸易市场的结构发展过程中,带来了新的机遇,新兴经济的地位在不断地上升,区域化贸易使贸易壁垒减少。',
        {
          img: require('@/assets/images/aboutMe/company_news01.jpg')
        },
        '汽车、计算机制造、航空航天、仪器仪表、飞机、医药品、光电技术产品等也是中国对外贸易中的弱项，每年都需要大量进口国外的产品。而中国在对外贸易中的强项首推机电类产品，中国每年出口产品的约一半都是机电类产品；其次则是计算机与通讯技术产品，毕竟在电脑整机、手机以及其他通讯类产品上中国都具有不少世界知名级企业。',
        '坤恒科技力争在立足国内市场的基础上，在国际市场上能否为国家贡献力量！'
      ]
    }
  ],
  positionList: [
    {
      name: '商务支持1名',
      address: '北京',
      time: '长期',
      education: '专科以上',
      monthly: '面议',
      age: '25~35周岁',
      requirement: ['勤奋踏实、工作主动、责任心强；', '具备良好的沟通协调能力；', ' 有良好的计算机基础，熟悉Office软件；', '管理、财会、电子、计算机等相关专业优先考虑； ', '具备行政管理或商务助理经验者优先考虑。'],
      duty: ['公司订单、合同的制作，销售合同及商务文件的管理和保管； ', '按照实际销售合同订立情况进行出入库手续的流程办理；', '负责销售数据的及时录入ERP汇总，并对销售数据进行分析；', '依据统计整理的数据资料，向经理提交参考建议与方案；', '配合销售人员与客户进行沟通联系，以及项目相关的报价信息查询；', '负责公司各项人事行政管理制度的编制、完善和贯彻执行；', '与其他部门协作负责改善与公司经营相关的财务、人事工作。']
    },
    {
      name: '业务经理2名',
      address: '北京，深圳',
      time: '长期',
      education: '本科及以上',
      monthly: '面议',
      age: '26~32周岁',
      requirement: ['诚信、积极、主动，良好的沟通及谈判能力；', '能承受压力，责任心强，具备良好的应变能力及团队合作精神；', '具有一定的计算机、电子知识基础，熟悉通信系统市场和应用；', '要求在电子行业有三年以上销售经验，有客户群基础者优先；', '通信及电子等相关专业背景者优先考虑。'],
      duty: ['负责本人销售计划的制订、执行；', '维护公司现有客户，并对客户进行具有针对性的有效管理；', '负责挖掘或激发客户的新需求；', '负责所辖市场产品线客户群的拓展；', '负责所辖产品与客户的售前、售中及售后的支持与服务. ']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/datas/news.js